import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "separate-upload"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
import { ref, onMounted, watch } from "vue";
import { ElMessage } from "element-plus";
import { uploadFile } from "@/service/modules/upload";
export default /*@__PURE__*/_defineComponent({
  __name: 'separate-upload',
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    maxSize: {
      type: Number,
      default: 5
    },
    fileTypes: {
      type: Array,
      default: () => []
    },
    accept: {
      type: String,
      default: ""
    },
    img1Url: {
      type: String,
      default: ""
    }
  },
  emits: ["uploadSuccess", "typeError"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const imgUrl = ref();
    const isUploading = ref(false);
    const progress = ref(0);
    const fileRef = ref(null);
    /**
     * 自定义上传
     */
    async function uploadFileFn(options) {
      const file = options.file;
      fileRef.value = file;
      try {
        const res = await uploadFile({
          file: options.file,
          uploadProgress: e => {
            isUploading.value = true;
            progress.value = Math.floor(e.loaded / e.total * 100);
            // progress.value = ((e.loaded / e.total) * 100).toFixed(2) as unknown as number
          }
        });
        isUploading.value = false;
        progress.value = 0;
        imgUrl.value = res.data[0];
        emit("uploadSuccess", imgUrl.value);
        ElMessage.success(`上传成功`);
      } catch {
        isUploading.value = false;
        progress.value = 0;
        ElMessage.error(`上传失败，请重新上传`);
      } finally {
        fileRef.value = null;
      }
    }
    /**
     * 限制用户上传文件的格式和大小
     */
    function handleBeforeUpload(file) {
      // console.log('file', file)
      if (props.fileTypes.length > 0 && !props.fileTypes.includes(file.type)) {
        emit("typeError");
        return false;
      }
      if (file.size > props.maxSize * 1048 * 1048) {
        ElMessage.warning(`上传文件不能大于${props.maxSize}M`);
        return false;
      }
      return true;
    }
    onMounted(() => {
      imgUrl.value = props.img1Url;
    });
    watch(() => props.img1Url, newV => {
      imgUrl.value = newV;
    });
    return (_ctx, _cache) => {
      const _component_Plus = _resolveComponent("Plus");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_progress = _resolveComponent("el-progress");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!isUploading.value ? (_openBlock(), _createBlock(_component_el_upload, {
        key: 0,
        class: "single-uploader",
        "show-file-list": false,
        "list-type": "picture-card",
        "before-upload": handleBeforeUpload,
        "http-request": uploadFileFn,
        accept: __props.accept
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [!imgUrl.value ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          class: "pic-icon"
        }, {
          default: _withCtx(() => [_createVNode(_component_Plus)]),
          _: 1
        })) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "up-img",
          src: imgUrl.value,
          alt: ""
        }, null, 8, _hoisted_2))])]),
        _: 3
      }, 8, ["accept"])) : (_openBlock(), _createBlock(_component_el_progress, {
        key: 1,
        percentage: progress.value,
        type: "circle",
        width: 100
      }, {
        default: _withCtx(() => [progress.value < 100 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(progress.value) + "%", 1)) : progress.value >= 100 && fileRef.value.size > 1048 * 1048 * 3 ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 转码中... ")) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["percentage"]))]);
    };
  }
});